import React, { Component } from 'react';
import './CharityCard.css';

class CharityCard extends Component {
    render() {
        const { title, imageLogo } = this.props.item;

        return (
            <div className="charity-card tikki-shadow">
                <div>
                    <img
                        src={imageLogo}
                        alt=""
                        className="charity-card-md-logo responsive-img"
                    />
                </div>
                <div>
                    <p className="charity-card-title">{title}</p>
                </div>
            </div>
        );
    };
};

export default CharityCard;



// WEBPACK FOOTER //
// ./src/components/Charities/CharityCard.js